import { Box, ButtonBase, Divider, Modal, Stack, Typography } from "@mui/material"
import { useState } from "react"
import FlexBetween from "../components/flexbox/FlexBetween"
import { fCurrency } from "../utils/format"
import FlexRowAlign from "../components/flexbox/FlexRowAlign"

export default function Roadmap() {
    const [open, setOpen] = useState(false)
    return <>
        <ButtonBase onClick={() => setOpen(true)}>
            <Typography sx={{ color: '#989898' }}>Codium</Typography>
        </ButtonBase>
        <Modal open={open} sx={{ background: "#000" }}>
            <Stack overflow={'scroll'} height={'100vh'} pb={8}>
                <img src="/images-asset/roadmap.png" style={{ width: '100%' }} />
                <ButtonBase onClick={() => setOpen(false)} sx={{ position: 'absolute', bottom: '10px', left: '50%', translate: '-50% 0px', background: '#fff', color: "#000", fontSize: '1.1rem', width: '90%', lineHeight: '30px', fontWeight: 500 }}>
                    Close
                </ButtonBase>
            </Stack>
        </Modal>
    </>
}